import React, { Component } from 'react';
import Header from '../../components/Header';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import AboutUs from '../../components/AboutUs';
import IconBox from '../../components/IconBox';
import TabBox from './../../components/TabBox';
import TestimonialSlider from '../../components/TestimonialSlider';
import FaqEvent from '../../components/FaqEvent';
import Footer from '../../components/Footer';
import { Styles } from "./styles/about.js";
import TeamList from '../../components/TeamSlider.js';

class About extends Component {

    render() {
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper about-page">

                    {/* Header 2 */}
                    <Header />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title="About Us" />

                    {/* About Area */}
                    <AboutUs />

                    {/* Icon Box Area */}
          <h1 style={{color: "#ff6f6f", textAlign: "center", paddingBottom: "30px"}} >Why We Are The Best</h1>
                    <IconBox />

                    {/* Tab Section */}
                    {/* <TabBox /> */}

                    <TeamList />

                    {/* Testimonial Slider */}
                    <TestimonialSlider />

                    {/* Faq & Event Area */}
                    <FaqEvent />

                    {/* Footer 2 */}
                    <Footer />

                </div>
            </Styles>
        )
    }
}

export default About